import actionCreator from '../../../utils/actionCreator';

const statisticActionTypes = [
  'GET_DASHBOARD',
  'GET_STATISTICS_FINANCE',
  'GET_STATISTICS_BOOKINGS',
  'GET_STATISTICS_QUEUE',
  'GET_STATISTICS_CLIENTS',
  'UNLOCK_STATISTICS',
  'STATISTICS_LOCKED',
  'STATISTICS_SESSION_RESET',
];

export const { types: statisticTypes, actions: statisticActions } = actionCreator(statisticActionTypes);
